import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import { checkUserPermission } from "../../common/UserPermission";
import { Noimage } from "../../common/imagePath";
import moment from "moment";

const ItemsDetailsModal = ({ id }) => {
  const [toggleItemsPrice, setToggleItemsPrice] = useState(false);
  const [toggleItemVariationPrice, setToggleItemVariationPrice] =
    useState(false);
  const [itemsDetailsData, setItemsDetailsData] = useState();
  const [itemsInventoryData, setItemsInventoryData] = useState([]);
  const navigate = useNavigate();

  console.log(itemsDetailsData, "itemsDetailsData");
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");

  const edithandel = (e) => {
    navigate(`/manage-Items/${itemsDetailsData?.ItemInfo[0]?.ID}`);
  };
  const generateBarcode = (e) => {
    const ItemID = itemsDetailsData?.ItemInfo[0]?.ID;
    const variationsData = itemsDetailsData?.ItemVariations;
    console.log(variationsData, "variationsData 052024");

    const newArray = variationsData?.map((item) => ({
      variationId: item.ID,
      itemId: ItemID,
    }));

    const barcodeRequestParam = {
      id: newArray,
    };

    console.log(newArray, "newArray 052024");
    console.log(barcodeRequestParam, "newArray 052024");

    localStorage.setItem(
      "BarcodeItemRequestParam",
      JSON.stringify(barcodeRequestParam)
    );

    // return
    navigate(`/item-barcode-label`);
  };

  useEffect(() => {
    if (id > 0) {
      axios
        .get(
          `${config.itemsBaseUrl}/items/detailsbinding?itemid=${id}&LocationID=${location}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // this.setState({ data: res.data.ResponseData });
          if (res.data?.ResponseData != undefined) {
            if (id > 0) {
              setItemsDetailsData(res.data.ResponseData);
            }
          }
          console.log("Show POPUP data =>", res.data.ResponseData);
        });

      // Get the current date
      const endDate = moment().format("YYYY-MM-DD");
      // Get the date 30 days ago
      const startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
      axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/inventoryquantitylisting?ItemID=${id}&Locationid=${location}&SupplierId=${0}&CustomerId=${0}&TransactionType=${0}&startDate=${startDate}&endDate=${endDate}&variation=0`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setItemsInventoryData(res.data.ResponseData);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    }
  }, [id]);

  const getListByInventoryID = itemsDetailsData?.Inventory.filter(
    (item) => item.LocationId === 45
  );
  console.log(itemsDetailsData, "itemsDetailsData");

  return (
    <>
      <div
        className="modal fade"
        id="ItemsDetailsModal"
        tabIndex={-1}
        // data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title p-lg">
                {itemsDetailsData?.ItemInfo[0].Name} [ID:{" "}
                {itemsDetailsData?.ItemInfo[0].ID}]{" "}
              </p>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div>
                    <ul className="nav nav-tabs d-flex justify-content-between">
                      <div className="d-flex">
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link active"
                            href="#ItemsDetailsTab1"
                            data-bs-toggle="tab"
                          >
                            Item Info
                          </a>
                        </li>
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTab2"
                            data-bs-toggle="tab"
                          >
                            Pricing
                          </a>
                        </li>
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTab3"
                            data-bs-toggle="tab"
                          >
                            Inventory
                          </a>
                        </li>
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTab4"
                            data-bs-toggle="tab"
                          >
                            Images
                          </a>
                        </li>
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTab5"
                            data-bs-toggle="tab"
                          >
                            Item Inventory Log
                          </a>
                        </li>
                      </div>

                      <button
                        className="col-md-1 btn btn-outline-dark custom-bg-dark-button-color "
                        style={{ marginBottom: "10px" }}
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={(e) => edithandel(e)}
                      >
                        Edit
                      </button>
                    </ul>
                  </div>
                  <div className="tab-content">
                    <div className="tab-pane show active" id="ItemsDetailsTab1">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <p
                                      className="p-medium"
                                      style={{
                                        color: "var(--primary-main-color)",
                                      }}
                                    >
                                      <i
                                        class="fa fa-info-circle  fa-lg mr-3"
                                        aria-hidden="true"
                                      ></i>
                                      Item Information
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="col-md-3">Category</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].Category}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">Description</td>
                                  <td
                                    style={{
                                      wordWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {itemsDetailsData?.ItemInfo[0].Description}
                                  </td>
                                </tr>

                                <tr>
                                  <td className="col-md-5">Item Id</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].ID}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">Product ID</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].ProductID}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">
                                    Allow Alt Description
                                  </td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0]
                                      .Allowaltdescription == 1
                                      ? "Yes"
                                      : "No"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">
                                    Item has Serial Number
                                  </td>
                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0]
                                      .IsItemserialnumber == 1
                                      ? "Yes"
                                      : "No"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">
                                    Generate Barcodes
                                  </td>
                                  <td className="col-md-9">
                                    {" "}
                                    <p
                                      onClick={() => generateBarcode()}
                                      className="cursor-pointer"
                                    >
                                      Print
                                    </p>{" "}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            {itemsDetailsData?.ItemVariations.length > 0 ? (
                              <table className="table mb-0 table-border">
                                <thead>
                                  <tr>
                                    <th colSpan={2}>
                                      <p
                                        className="p-medium ml-2"
                                        style={{
                                          color: "var(--primary-main-color)",
                                        }}
                                      >
                                        <i
                                          className="fa fa-th-list fa-lg mr-3"
                                          aria-hidden="true"
                                        ></i>
                                        Item Variations
                                      </p>
                                    </th>
                                    <th></th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="col-md-1"></td>
                                    <td className="col-md-3">Name</td>
                                    <td className="col-md-3">Attributes</td>
                                    {/* {checkUserPermission("suppliers") && (
                                    )} */}
                                    <td className="col-md-5">Supplier</td>
                                  </tr>
                                  {itemsDetailsData.ItemVariations.map(
                                    (items, index) => (
                                      <tr key={index}>
                                        <td>
                                          <img
                                            src={items.ImageName}
                                            onError={(e) => {
                                              e.currentTarget.src =
                                                Noimage ||
                                                "path/to/fallback/image.jpg";
                                            }}
                                            // alt={props.Name}
                                            className="img-thumbnail mr-5"
                                            width="45"
                                            height="45"
                                          />
                                        </td>
                                        <td className="col-md-3">
                                          {items.Name}
                                        </td>
                                        <td className="col-md-3">
                                          {items.Attribute}
                                        </td>
                                        {/* {checkUserPermission("suppliers") && (
                                         
                                        )} */}
                                         <td className="col-md-3">
                                            {items.Supplier}
                                          </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            ) : (
                              <div></div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTab2">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <p
                                      className="p-medium"
                                      style={{
                                        color: "var(--primary-main-color)",
                                      }}
                                    >
                                      <i
                                        class="fa fa-money mr-3"
                                        aria-hidden="true"
                                      ></i>
                                      Pricing
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="col-md-3">Selling Price</td>
                                  <td className="col-md-3">
                                    {Number(
                                      itemsDetailsData?.ItemInfo[0].Unitprice
                                    ).toFixed(2)}
                                  </td>
                                  <td className="col-md-3"></td>
                                </tr>
                                {checkUserPermission("show-cost-price") && (
                                  <tr>
                                    <td className="col-md-3">Cost Price</td>
                                    <td className="col-md-3">
                                      {toggleItemsPrice &&
                                        Number(
                                          itemsDetailsData?.ItemInfo[0]
                                            .Costprice
                                        ).toFixed(2)}
                                      <Link
                                        type="button"
                                        className="btn btn-sm btn-outline-dark"
                                        style={{
                                          height: "28px",
                                          width: "25px",
                                        }}
                                        onClick={() =>
                                          setToggleItemsPrice(!toggleItemsPrice)
                                        }
                                      >
                                        {!toggleItemsPrice ? (
                                          <>
                                            <i className="fa fa-plus"></i>{" "}
                                          </>
                                        ) : (
                                          <>
                                            <i className="fa fa-minus"></i>{" "}
                                          </>
                                        )}
                                      </Link>
                                    </td>
                                    <td className="col-md-3"></td>
                                  </tr>
                                )}
                                <tr>
                                  <th className="col-md-3">Variation</th>
                                  <th className="col-md-3">Selling Price</th>
                                  {checkUserPermission("show-cost-price") && (
                                    <th className="col-md-3">
                                      Cost Price
                                      <Link
                                        type="button"
                                        className="btn btn-sm btn-outline-dark"
                                        style={{
                                          height: "28px",
                                          width: "25px",
                                        }}
                                        onClick={() =>
                                          setToggleItemVariationPrice(
                                            !toggleItemVariationPrice
                                          )
                                        }
                                      >
                                        {!toggleItemVariationPrice ? (
                                          <>
                                            <i className="fa fa-plus"></i>{" "}
                                          </>
                                        ) : (
                                          <>
                                            <i className="fa fa-minus"></i>{" "}
                                          </>
                                        )}
                                      </Link>
                                    </th>
                                  )}
                                </tr>
                                {itemsDetailsData?.Pricing.map(
                                  (items, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="col-md-3">
                                          {items?.Name}
                                        </td>
                                        <td className="col-md-3">
                                          {Number(items?.SellingPrice).toFixed(
                                            2
                                          )}
                                        </td>
                                        {checkUserPermission(
                                          "show-cost-price"
                                        ) && (
                                          <td className="col-md-3">
                                            {toggleItemVariationPrice &&
                                              Number(items?.CostPrice).toFixed(
                                                2
                                              )}
                                          </td>
                                        )}
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTab3">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <p
                                      className="p-medium"
                                      style={{
                                        color: "var(--primary-main-color)",
                                      }}
                                    >
                                      <i
                                        class="fa fa-list-ul mr-3"
                                        aria-hidden="true"
                                      ></i>
                                      Inventory
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="col-md-3">Variation</td>
                                  <td className="col-md-3">Qty.</td>
                                  <td className="col-md-3">Replenish Level</td>
                                  <td className="col-md-3">Reorder Level</td>
                                </tr>

                                {itemsDetailsData?.Inventory.map(
                                  (items, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="col-md-3">
                                          {items?.Variation}
                                        </td>
                                        <td className="col-md-3">
                                          {Number(items?.Quantity).toFixed(2)}
                                        </td>
                                        <td className="col-md-3">
                                          {Number(
                                            items?.ReplenishLevel
                                          ).toFixed(2)}
                                        </td>
                                        <td className="col-md-3">
                                          {Number(items?.ReorderLevel).toFixed(
                                            2
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTab4">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <p
                                      className="p-medium"
                                      style={{
                                        color: "var(--primary-main-color)",
                                      }}
                                    >
                                      <i
                                        class="fa fa-picture-o mr-3"
                                        aria-hidden="true"
                                      ></i>
                                      Images
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {itemsDetailsData?.Images.map(
                                  (items, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="col-md-1">
                                          <img
                                            // className="d-flex  "
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                            src={items.Name}
                                            alt={items.ID}
                                            width="150"
                                            height="150"
                                          />
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTab5">
                      <div className="row">
                        <div className="col-md-12 mb-3 mt-3">
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th className="p-regular">Date</th>
                                  <th className="p-regular ">Item Variation</th>
                                  <th>Rate</th>
                                  <th className="p-regular">In/Out Qty</th>
                                  <th className="p-regular">Quantity Onhand</th>
                                  <th className="p-regular">Balance</th>
                                  <th className="p-regular">Type</th>
                                  {/* <th className="p-regular">ID</th> */}
                                  <th className="p-regular">Reference</th>
                                  <th className="p-regular">Invoice / Bill No.</th>
                                  <th className="p-regular">Comment</th>
                                </tr>
                              </thead>
                              <tbody>
                                {itemsInventoryData.length > 0 ? (
                                  itemsInventoryData.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.TransactionDate}</td>
                                      <td className="word-break-data">
                                        {item?.Name}
                                      </td>
                                      <td style={{ textAlign: "left" }}>
                                        {Number(item?.Price).toFixed(
                                          2
                                        )}
                                      </td>
                                      <td style={{ textAlign: "left" }}>
                                        {Number(
                                          item?.InventoryAddSubtraction
                                        ).toFixed(2)}
                                      </td>
                                      <td style={{ textAlign: "left" }}>
                                        {Number(item?.PastQuanitity).toFixed(2)}
                                      </td>
                                      <td style={{ textAlign: "left" }}>
                                        {Number(item?.CurrentQuantity).toFixed(
                                          2
                                        )}
                                      </td>
                                      <td> {item?.TransactionType}</td>
                                      {/* <td> {item?.Id}</td> */}
                                      <td className="word-break-data">
                                        {" "}
                                        {/* {item?.RefrenceNo} */}
                                        {item?.RefrenceNo?.split(',')[0]}

                                      </td>
                                      <td className="word-break-data">
                                        {" "}
                                        {/* {item?.RefrenceNo} */}
                                        {item?.RefrenceNo?.split(',')[1]}

                                      </td>
                                      <td> {item?.Comment}</td>
                                      {/* <td> {item?.CompanyName}</td> */}
                                    </tr>
                                  ))
                                ) : (
                                  <tr
                                    style={{
                                      textAlign: "center",
                                      columnSpan: 6,
                                    }}
                                  >
                                    <td>No Data</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="modal-footer justify-content-center">
              <Link
                className="btn btn-sm btn-outline-dark me-1 form-control text-align-center"
                data-bs-dismiss="modal"
              >
                Close
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemsDetailsModal;
